module.exports = __webpack_public_path__ + "img/journal-whills.c6f81f73.svg";